
import RcDomainMap from "../../common/RcDomainMap.js";
import SortUtils from "../SortUtils.js";
import Address from './Address.js';

export default class AddressMap extends RcDomainMap {
  static MODEL_NAME = Address.MODEL_NAME + "Map";

  constructor(domain, data) {
    super(domain, data, AddressMap.MODEL_NAME);
  }

  copy() {
    var data = this._copy();
    return new AddressMap(this.domain, data);
  }

  find() {
    var keys = this.keys();
    var found = new AddressMap(this.domain, {});
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAddress(key);
      if (item.isNew()) {
        found.add(item);
      } else {
        var data = this.domain.addresses().findById(key);
        item = new Address(this.domain, data);
        if (!item.isNew()) {
          found.add(item);
        }
      }
    }

    return found;
  }

   findTypePoi() {
    var found = new AddressMap(this.domain, {});
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAddress(key);
      if (item.isTypePoi()) {
        found.add(item);
      }
    }
    return found;
  }

  getAddress(key) {
    var value = super.get(key);
    return new Address(this.domain, value);
  }

  list() {
    var values = [];
    var keys = this.keys();
    for (var index = 0; index < keys.length; index++) {
      var key = keys[index];
      var item = this.getAddress(key);
      values.push(item);
    }
    return values;
  }

  sort() {
    var list = this.list();
    return list.sort(SortUtils.SortBy_createdDateAz);
  }

  sortByName() {
    var list = this.list();
    var result = list.sort(SortUtils.SortBy_nameAz);
    return result;
  }
}